module.exports = __webpack_public_path__ + "img/American-Express.5adb7e3.svg";